import { render, staticRenderFns } from "./TiposQuestao.vue?vue&type=template&id=f7fadcf2&scoped=true&"
import script from "./TiposQuestao.vue?vue&type=script&lang=js&"
export * from "./TiposQuestao.vue?vue&type=script&lang=js&"
import style0 from "./TiposQuestao.vue?vue&type=style&index=0&id=f7fadcf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fadcf2",
  null
  
)

export default component.exports